"use client";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@frontend/shared/components/ui/tooltip";
import { cn } from "@frontend/shared/lib/utils";
import { Info } from "lucide-react";

interface PendingPricesMessageProps {
  className?: string;
}

/**
 * Shared component for displaying "Insurance pricing pending" message
 * Used throughout the storefront when in pending prices mode
 *
 * @param className - Optional className to apply to the wrapper div
 */
export function PendingPricesMessage({
  className = "",
}: PendingPricesMessageProps) {
  return (
    <div className={cn(className)}>
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger
            asChild
            className="inline-flex items-center justify-center cursor-pointer hover:opacity-70 transition-opacity ml-1"
          >
            <Info className="w-[26px] h-[26px] text-superscriptBlue" />
          </TooltipTrigger>
          <TooltipContent className="shadow-xl">
            <p className="text-xs text-gray-600 w-56">
              Insurance pricing pending, your appointment will be reserved and
              payment will be collected after prices are confirmed by an
              administrator at the time of your visit.
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
